import { PostHogErrorBoundary, PostHogProvider } from "@posthog/react"
import React from "react"
import ReactDOM from "react-dom/client"

import posthog from "./posthog"

const root = document.getElementById("root") as HTMLElement

const bootstrap = async () => {
  if (window.location.pathname.startsWith("/preview/")) {
    const { PreviewApp } = await import("./preview/PreviewApp")
    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <PreviewApp />
      </React.StrictMode>
    )
    return
  }

  await import("./instrument")
  if (import.meta.env.VITE_HOTJAR_ID) {
    const Hotjar = (await import("@hotjar/browser")).default
    Hotjar.init(parseInt(import.meta.env.VITE_HOTJAR_ID), 6)
  }
  const { default: App } = await import("./App")
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <PostHogProvider client={posthog}>
        <PostHogErrorBoundary>
          <App />
        </PostHogErrorBoundary>
      </PostHogProvider>
    </React.StrictMode>
  )
}

void bootstrap()
